import CollapsablePreviewArea from './components/CollapsablePreviewArea'
import ContextProvider from './context/PreviewerContextProvider'
import './global.css'

export function App(): JSX.Element {
    return <ContextProvider>
    <CollapsablePreviewArea />
    </ContextProvider>
}